import { create } from "zustand";
import { executeLogin } from "../helper/Api";
import { LoginRequest, User } from "../types/User";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
interface AdminUserStore {
    isAdminAuth: boolean;
  token: string | null;
  login: (user: LoginRequest,  showToast: (message: string, severity: "info" | "success" | "error" | "warning") => void) => Promise<void>;
  logout: () => void;
}

const useAdminUserStore = create<AdminUserStore>((set) => {
  const storedToken = Cookies.get("admin-token");
  const isAdminAuth = !!storedToken;
  return {
    isAdminAuth,
    token: storedToken || null,

    login: async (loginRequest, showToast) => {
      try {
        const result = await executeLogin<{ username: string; password: string }>(
          "Admin/LoginAdmin",
          loginRequest
        );
        if(result!=null){
          const { token } = result;
          const expiresInHours = 1; // 1 hour expiration
          const expirationDate = new Date(Date.now() + expiresInHours * 60 * 60 * 1000);
          Cookies.set("admin-token", token, { expires: expiresInHours / 24 });
          Cookies.set("admin-token-expires", expirationDate.toISOString(), { 
            expires: expiresInHours / 24 
          });
          set({ isAdminAuth: true, token: token });
        } else {
          showToast("Wrong User credentials !", "error");
        }
      } catch (error) {
        console.error("Login error: ", error);
        showToast("An unexpected error occurred during login.", "error");
        throw error;
      }
    },

    logout: () => {
      Cookies.remove("admin-token");
      set({ isAdminAuth: false, token: null });
    },
  };
});

export default useAdminUserStore;
